import * as URLConfig from "../domain";

const config = URLConfig.config;

export default {
	saveLeadInfoV1: config.web_mw + "Oyo/saveleadinfo_V1", //POST
	getLeadMasterDetails: config.web_mw + "Oyo/getLeadMasterDetails/" //GET
};
